import { Controller } from '@hotwired/stimulus'

// Generic add/remove form rows: clones the <template> target's DOM (no HTML
// string parsing), stamping __INDEX__ in name/data attributes with a fresh
// numeric index. Rows mark themselves with data-repeater-row="<index>" and
// remove via data-action="repeater#remove". Indexes only ever grow
// (max existing + 1), so removing a middle row can never make a later add
// collide with a survivor.
export default class extends Controller {
  static targets = ['template', 'container']

  add (event) {
    event.preventDefault()
    const index = String(this.nextIndex())
    const fragment = this.templateTarget.content.cloneNode(true)
    fragment.querySelectorAll('[name]').forEach((el) => {
      el.name = el.name.replaceAll('__INDEX__', index)
    })
    fragment.querySelectorAll('[data-repeater-row]').forEach((el) => {
      el.dataset.repeaterRow = index
    })
    this.containerTarget.appendChild(fragment)
  }

  remove (event) {
    event.preventDefault()
    event.target.closest('[data-repeater-row]')?.remove()
  }

  nextIndex () {
    const rows = this.containerTarget.querySelectorAll('[data-repeater-row]')
    return Array.from(rows).reduce(
      (max, row) => Math.max(max, Number.parseInt(row.dataset.repeaterRow, 10) + 1 || 0),
      rows.length
    )
  }
}
